module.exports = __webpack_public_path__ + "media/images/subscription-promo-desktop-no-shadow-a5b9150699313c1f011a38f88d7f6163.png";